// extracted by mini-css-extract-plugin
export default {"instacartButton":"RecipeDetailsView_instacartButton__HptIy","statGridContainer":"RecipeDetailsView_statGridContainer__G-8Ld","statGrid":"RecipeDetailsView_statGrid__LKKDP"};